<p-card class="card-spacing-0">
  <div class="billers-list p-3">
    <header
      class="samplepo-header d-flex align-items-center justify-content-between has-border pb-2 mb-2">
      <h2 class="mb-0">Portal Biller</h2>
    </header>
    <p-table
      #dt
      stripedRows
      [rowHover]="true"
      [rows]="25"
      [showCurrentPageReport]="true"
      [scrollable]="true"
      scrollHeight="calc(100vh - 310px)"
      [size]="'small'"
      [resizableColumns]="true"
      responsiveLayout="scroll"
      [value]="BillerListing"
      styleClass="p-datatable-customers no-overfollow ordersLineItems no-wrap table-hover-bg"
      [rowHover]="true"
      [rows]="20"
      [showCurrentPageReport]="true"
      [paginator]="false"
      [filterDelay]="0"
      dataKey="id"
      editMode="row"
      selectionMode="multiple"
      styleClass="table-listing">
      <ng-template pTemplate="header">
        <tr class="table-head">
          <th></th>
          <th class="number">Personal #</th>
          <th class="status">Name</th>
          <th class="name">Phone</th>
          <th class="name">Email</th>
        </tr>
        <tr>
          <th></th>
          <th>
            <div class="d-flex">
              <input
                jniAutoCompleteBlocker
                pInputText
                type="text"
                name="personnelNumber"
                id="personnelNumber"
                style="max-width: 200px"
                (input)="
                  dt.filter(
                    $any($event.target).value,
                    'personnelNumber',
                    'contains'
                  )
                "
                placeholder=""
                class="p-column-filter p-inputtext p-component" />
            </div>
          </th>
          <th>
            <div class="d-flex">
              <input
                jniAutoCompleteBlocker
                pInputText
                type="text"
                name="name"
                id="name"
                style="max-width: 200px"
                (input)="
                  dt.filter($any($event.target).value, 'name', 'contains')
                "
                placeholder=""
                class="p-column-filter p-inputtext p-component" />
            </div>
          </th>
          <th>
            <div class="d-flex">
              <input
                jniAutoCompleteBlocker
                pInputText
                type="text"
                name="phone"
                id="phone"
                style="max-width: 200px"
                (input)="
                  dt.filter($any($event.target).value, 'phone', 'contains')
                "
                placeholder=""
                class="p-column-filter p-inputtext p-component" />
            </div>
          </th>
          <th>
            <div class="d-flex">
              <input
                jniAutoCompleteBlocker
                pInputText
                type="text"
                name="email"
                id="email"
                style="max-width: 200px"
                (input)="
                  dt.filter($any($event.target).value, 'email', 'contains')
                "
                placeholder=""
                class="p-column-filter p-inputtext p-component" />
            </div>
          </th>
        </tr>
      </ng-template>
      <ng-template
        pTemplate="body"
        let-BillerListing
        let-editing="editing"
        let-rowIndex="rowIndex">
        <tr
          class="p-selectable-row"
          [ngClass]="{ 'line-gray': !BillerListing?.isActive }">
          <td style="text-align: center">
            <button
              [disabled]="!BillerListing?.isActive"
              pButton
              pRipple
              type="button"
              (click)="onEditRow(BillerListing)"
              icon="pi pi-pencil"
              class="p-button-rounded p-button-text">
              Biller
            </button>
          </td>
          <td>{{ BillerListing.personnelNumber }}</td>
          <td>{{ BillerListing.name }}</td>
          <td>{{ BillerListing.phone }}</td>
          <td>{{ BillerListing.email }}</td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</p-card>
